import React, { useState } from "react";
import {
  Col,
  Row,
  Form,
  Radio,
  Spin,
  Pagination,
  TimePicker,
  DatePicker,
} from "antd";
import {
  StyledInput,
  SearchButton,
  SendMessageInput,
  Topic,
  SpaceListContainer,
  ModalContainer,
  CreateSpace,
} from "../Chat/Style";
import { StyledInput as TextArea } from "../Post/style";
import { FaSearch } from "react-icons/fa";
import { FiPlus } from "react-icons/fi";
import { useHistory, useLocation } from "react-router-dom";
import { ModalComponent } from "../../globalComponents/Modal";
import { Label } from "../../globalComponents/globalStyle";
import DiscussionCardItem from "./components/DiscussionCardItem";
import styled from "styled-components";
import { BiCalendar, BiInfoSquare, BiLock, BiPencil } from "react-icons/bi";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import {
  CREATE_VOICE_CHAT,
  GET_VOICE_CHATS,
  JOIN_VOICE_CHAT,
} from "../../app/apollo";
import { NotificationAlert } from "../../utils/NotificationAlert";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { setRoomTokenAndId } from "../../app/store";
import { BsSpeaker } from "react-icons/bs";
import { motion } from "framer-motion";
import { Text } from "../Education/style";
import { CreateDiscussion } from "./Style";
import { PasswordInput, TextInput } from "../../globalComponents/TextInput";
import { LoggerButton } from "../../globalComponents/Button";
import { valuesIn } from "lodash";
import { StyledDataPicker } from "../Onboard/Style";

const Community: React.FC = () => {
  const history = useHistory();
  const [privateGroup, setPrivateGroup] = useState<boolean>(false);
  const { pathname } = useLocation();
  const [addSpace, setAddSpace] = useState<boolean>(false);
  const [joinSpace, setJoinSpace] = useState<boolean>(false);
  const [spaceValue, setSpaceValue] = useState<any>(null);
  const dispatcher = useAppDispatch();
  const roomState = useAppSelector((state) => state.room);
  const userState = useAppSelector((state) => state.userInfoReducer.content);
  const [data, setVoiceChatList] = useState<any>([]);
  const [currentPage, setCurrentPage] = React.useState<any>(1);
  const [allPages, setAllPages] = React.useState<any>();
  const [loading, setLoading] = React.useState<boolean>(false);
  const [joinVoiceChat, joinVoiceChatData] = useMutation(JOIN_VOICE_CHAT);
  const [createVoiceChat, createVoiceChatData] = useMutation(CREATE_VOICE_CHAT);
  const [voiceSearch, voiceSearchData] = useLazyQuery(GET_VOICE_CHATS);

  // const { data, loading, error } = useQuery(GET_VOICE_CHATS, {
  //   variables: {
  //     byCountry: "",
  //     byCity: "",
  //     requestedPage: currentPage,
  //     // byCategory:""
  //   },
  // });

  React.useEffect(() => {
    fetchVoiceList("", "", currentPage);
  }, []);
  console.log("chat list", voiceSearchData);
  React.useEffect(() => {
    if (voiceSearchData?.error) {
      NotificationAlert("error", "Error ocurred", "Try again");
    } else if (voiceSearchData?.data?.getVoiceChats?.VoiceChat) {
      setVoiceChatList(voiceSearchData?.data);
      setAllPages(voiceSearchData?.data?.getVoiceChats?.last_page);
    }
  }, [voiceSearchData]);

  const fetchVoiceList = async (
    country: string,
    city: string,
    current: number
  ) => {
    try {
      voiceSearch({
        variables: {
          byCountry: "",
          byCity: "",
          requestedPage: current,
        },
      });
    } catch (e) {
      NotificationAlert("error", "Error occured", "Try Again");
    }
  };

  const onFinish = async (values: any) => {
    setLoading(true);
    console.log("create community");
    const password = values?.password
      ? { room_password: values?.password }
      : null;
    try {
      const response = await createVoiceChat({
        refetchQueries: [{ query: GET_VOICE_CHATS }],
        variables: {
          title: values?.topic,
          category: 1,
          country: userState?.currrentCountry?.country,
          moderators: [+userState?.id],
          description: values?.description,
          channel_type: privateGroup ? true : false,
          schedule_time: values?.time.format("YYYY-MM-DD HH:mm:ss"),
          ...password,
          speakers: [+userState?.id],
        },
      });
      if (response) {
        console.log("create room reponse", response);
        setLoading(false);
        if (response?.data?.createVoiceChat?.success) {
          handleAddSpace();
          NotificationAlert(
            "success",
            "Space Created",
            `${values?.topic} successfully created`
          );
        } else {
          NotificationAlert(
            "error",
            "Counld not create space",
            response?.data?.createVoiceChat?.msg
          );
        }
      }
    } catch (e) {
      console.log("create a room log", e);
      setLoading(false);
      NotificationAlert("error", "Error Occured", "Try Again");
    }
  };
  console.log(voiceSearchData.error);

  const handleJoinVoiceChat = ({
    chatId,
    title,
    speakers,
    moderators,
  }: {
    chatId: number;
    title: string;
    speakers: string[];
    moderators: string[];
  }) => {
    console.log(speakers, "speakers");
    console.log("my id", userState?.id);
    const canSpeak = speakers
      ?.map((item) => `${item}`)
      ?.includes(`${userState?.id}`);
    const isModrator = moderators
      ?.map((item) => `${item}`)
      ?.includes(`${userState?.id}`);
    console.log(canSpeak, "can speakd");
    joinVoiceChat({
      variables: {
        chatId: chatId,
      },
    })
      .then((resp) => {
        console.log(resp?.data?.joinVoiceChat);
        if (resp?.data?.joinVoiceChat?.success) {
          dispatcher(
            setRoomTokenAndId({
              token: resp?.data?.joinVoiceChat?.access_token,
              id: chatId,
              title,
              canSpeak,
              isModrator,
            })
          );
          history.push(`${pathname}/com${chatId}`, { isSpeaker: canSpeak });
          setJoinSpace(false);
          return;
        }
        setJoinSpace(false);
        NotificationAlert("error", "Error!", resp?.data?.joinVoiceChat?.err);
      })
      .catch((err) => {
        NotificationAlert("error", "Server Error", err);
        setJoinSpace(false);
      });
  };

  const handleAddSpace = () => {
    setAddSpace(!addSpace);
  };

  const handleJoinSpace = (val: any) => {
    if (val.id === roomState.joinedRoomId && roomState.joinedRoomToken) {
      history.push(`${pathname}/com${val.id}`);
      return;
    }
    setJoinSpace(!addSpace);
    val && setSpaceValue(val);
    if (true && true) {
      console.log(val);
      console.log(roomState);
    }
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log(errorInfo);
  };
  const handleBackChange = () => {
    if (currentPage > 1) {
      fetchVoiceList("", "", currentPage);
      setCurrentPage(currentPage - 1);
    }
  };
  const handleForwardChange = () => {
    if (currentPage < allPages) {
      fetchVoiceList("", "", currentPage);
      setCurrentPage(currentPage + 1);
    }
  };
  function itemRender(current?: any, type?: any, originalElement?: any) {
    if (type === "prev") {
      return (
        <h5 style={{ color: "blue", margin: 0 }} onClick={handleBackChange}>
          Previous
        </h5>
      );
    }
    if (type === "next") {
      return (
        <h5 style={{ color: "blue", margin: 0 }} onClick={handleForwardChange}>
          Next
        </h5>
      );
    }
    return originalElement;
  }

  const topicsList = data?.getVoiceChats?.VoiceChat?.map(
    (topic: any, id: number) => (
      <motion.div key={topic.id} animate={{ x: 3 * id }}>
        <DiscussionCardItem
          key={topic.id}
          title={topic.title}
          hostName={`${topic?.host?.firstname} ${topic?.host?.lastname}`}
          hostImage={topic?.host?.photolink}
          roomType={topic.channel_type}
          country={topic?.country}
          time={topic?.schedule_time}
          onClick={() => handleJoinSpace(topic)}
        />
      </motion.div>
    )
  );
  return (
    <div style={{ width: "100%" }}>
      {voiceSearchData.loading && (
        <Row>
          <Text>loading... please wait</Text> <Spin />
        </Row>
      )}
      <Row justify="space-between" style={{ padding: "0.2vw 0" }}>
        <Col md={{ span: 15 }}>
          <TopicSearchBar
            style={{ display: "flex", alignItems: "center", height: "100%" }}
          >
            <StyledInput
              bordered={false}
              placeholder="Search Topics,Rooms or Host..."
            />
            <SearchButton>
              <FaSearch />
            </SearchButton>
          </TopicSearchBar>
        </Col>
        <Col md={{ span: 3 }}>
          <CreateSpace onClick={handleAddSpace}>
            <div>
              <FiPlus />
            </div>{" "}
            <h3>Create a Space</h3>
          </CreateSpace>

          {/**
           *
           * Show join dialog
           *
           */}
          <ModalComponent
            onCancel={() => setJoinSpace(false)}
            visible={joinSpace}
          >
            <ModalContainer>
              <h3 className="title-medium">
                You are about to join a new discussion
                {roomState.joinedRoom
                  ? ", your discussion in the other room will be end."
                  : "."}
              </h3>

              <BsSpeaker size={40} />

              <h2>
                #<span>{spaceValue?.title}</span>
              </h2>

              <h4>
                Created by: <span>{spaceValue?.creator}</span>{" "}
              </h4>
              {spaceValue?.channel_type == "PRIVATE" && (
                <div className="is-auth-room">
                  <p>
                    This is a private room kindly, provide the room's password
                    below
                  </p>
                  <input></input>
                </div>
              )}
              <button
                onClick={() => {
                  //   handleJoinVoiceChat({ chatId: spaceValue?.id });
                  handleJoinVoiceChat({
                    chatId: spaceValue?.id,
                    title: spaceValue?.title,
                    speakers: spaceValue?.speakers,
                    moderators: spaceValue?.moderators,
                  });
                }}
                className="title-medium"
              >
                {roomState.joinedRoom ? "End & Join" : "Join"}
              </button>
            </ModalContainer>
          </ModalComponent>

          {/**
           *
           * Modal to create new discussion room
           *
           */}
          <ModalComponent onCancel={handleAddSpace} visible={addSpace}>
            <ModalContainer>
              <CreateDiscussion>
                <h3 className="title-bold">Create a new Space</h3>
                <Radio.Group defaultValue={"public"}>
                  <Radio
                    onChange={() => {
                      setPrivateGroup(false);
                    }}
                    className="radio-x title-medium"
                    value="public"
                  >
                    Public
                  </Radio>
                  <Radio
                    onChange={() => {
                      setPrivateGroup(true);
                    }}
                    className="radio-x title-medium"
                    value="private"
                  >
                    Private
                  </Radio>
                </Radio.Group>
                <br />
                <Form
                  layout="vertical"
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                >
                  <Form.Item
                    name="topic"
                    rules={[
                      {
                        required: true,
                        message: "field is required",
                      },
                    ]}
                    label={
                      <Label style={{ color: "gray" }}>
                        <BiInfoSquare size={20} />
                        <h3 className="title-bold">Add Topic</h3>
                      </Label>
                    }
                  >
                    <div>
                      <TextInput
                        required={true}
                        type="text"
                        placeholder="Create topic"
                      />
                    </div>
                  </Form.Item>
                  <Form.Item
                    name="description"
                    rules={[
                      {
                        required: true,
                        message: "field is required",
                      },
                    ]}
                    label={
                      <Label style={{ color: "gray" }}>
                        <BiPencil size={20} />
                        <h3 className="title-bold">Add Description</h3>
                      </Label>
                    }
                  >
                    <div>
                      <TextArea
                        autoSize={{ minRows: 3, maxRows: 3 }}
                        required={true}
                        placeholder="Enter your topic description"
                      />
                    </div>
                  </Form.Item>
                  {privateGroup && (
                    <Form.Item
                      name="password"
                      rules={[
                        {
                          required: true,
                          message: "field is required",
                        },
                      ]}
                      label={
                        <Label style={{ color: "gray" }}>
                          <BiLock size={20} />
                          <h3 className="title-bold">Add password</h3>
                        </Label>
                      }
                    >
                      <div>
                        <PasswordInput
                          required={true}
                          type="text"
                          placeholder="Enter Space Password"
                        />
                      </div>
                    </Form.Item>
                  )}
                  <Form.Item
                    name="time"
                    rules={[
                      {
                        required: true,
                        message: "field is required",
                      },
                    ]}
                    label={
                      <Label style={{ color: "gray" }}>
                        <BiCalendar size={20} />
                        <h3 className="title-bold">Add Time</h3>
                      </Label>
                    }
                  >
                    <DatePicker showTime format="YYYY-MM-DD HH:mm:ss" />
                  </Form.Item>
                  <LoggerButton
                    loading={loading}
                    // width="40%"
                    htmlType="submit"
                    text="Create "
                  />
                </Form>
              </CreateDiscussion>
            </ModalContainer>
          </ModalComponent>
        </Col>
      </Row>

      <SpaceListContainer>
        <h3>Find conversations around you</h3>
        <Row justify="start">{topicsList}</Row>{" "}
        {data?.getVoiceChats?.VoiceChat?.length > 0 && (
          <Pagination
            style={{ marginBottom: "10vh" }}
            current={currentPage}
            total={allPages}
            pageSize={1}
            defaultPageSize={allPages}
            showSizeChanger={false}
            itemRender={itemRender}
            showTotal={(total) => `Total: ${total} list`}
          />
        )}
      </SpaceListContainer>
    </div>
  );
};

const TopicSearchBar = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  max-width: 400px;
  border-radius: 15px;
  overflow: hidden;
  background: ${(prop) => prop.theme.foreground};
  padding: 4px 10px;
`;

export default Community;
